import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import classes from './MoreComponent.css';
import translation from '../../assets/data/LocalizedStrings/LocalizedStrings.json';

const moreComponent = props => {
  const { language } = props;
switch (language) {
    // English content
    case 'en':
      return (
        <Fragment>
            <div className={classes.ContactInfoWrapper}>
                <p>The Schneider Electric Customer Care Center (CCC) is a single point of contact where qualified personnel answer your customer service and technical support questions. Two support centers are offered to support customers calling from both Canada and from the United States. Please select the call center for your country.</p>
                <p><b>Canada</b><br />
                In Canada call: <a href="tel:1-800-565-6699" title="tap to call">1-800-565-6699</a> (<a href="https://www.schneider-electric.ca/en/work/support/customer-care/contact-directory" title="details on the web">details</a>)<br />
                Press 1 for French<br />
                Press 2 for English</p>
                <p>Technical Support is available Monday - Friday, 8:00am - 7:00pm (English) and 8:00am - 5:00pm (French) (EST)<br />
                <i>(Note: Some support departments may end earlier)</i>
                </p>
                <p>Email: <a href="mailto:canadian-pss@schneider-electric.com" title="email support">Contact Support</a><br />
                Website: <a href="https://www.schneider-electric.ca/CIC" title="visit website">https://www.schneider-electric.ca/CIC</a>
                </p>
                <p>&nbsp;</p>
                <p><b>United States</b><br />
                In USA call: <a href="tel:1-877-342-5173" title="tap to call">1-877-342-5173</a> (<a href="https://www.schneider-electric.us/en/work/support/customer-care" title="details on the web">details</a>)<br />
                Technical Support is available Monday - Friday, 8:00am - 8:00pm (EST)<br />
                <i>(Note: Some support departments may end earlier)</i>
                </p>
                <p>Chat: <a href="
                https://www.schneider-electric.us/en/work/support/customer-care" title="contact support">Chat with support</a><i> (same hours as technical support)</i><br />
                Website: <a href="https://www.schneider-electric.us/en/work/support" title="visit website">https://www.schneider-electric.us/en/work/support</a>
                </p>
                </div>
                <div className={classes.TitleWrapper}>
                <h2>{translation[language].contactUs}</h2>
            </div>
        </Fragment>
        );

    // French content
    case 'fr':
      return (
        <Fragment>
            <div className={classes.ContactInfoWrapper}>
                <p>Le Customer Care Center (CCC) de Schneider Electric est un point de contact unique où un personnel qualifié répond à vos questions concernant le service client et le support technique. Vous avez deux centres de support pour aider les clients du Canada et des États-Unis.</p>
                <p><b>Canada</b><br />
                Au Canada, appelez: <a href="tel:1-800-565-6699" title="appuyez sur pour appeler">1-800-565-6699</a> (<a href="https://www.schneider-electric.ca/fr/work/support/" title="détails sur le web">details</a>)<br />
                Appuyez sur le 1 pour Français<br />
                Appuyez sur le 2 pour Anglais</p>
                <p>Le support technique est disponible du lundi au vendredi de 8h00 à 19h00 (en anglais) et de 8h00 à 17h00 (en français)<br />
                <i>(Remarque: certains départements de support peuvent se terminer plus tôt)</i>
                </p>
                <p>Email: <a href="https://www.schneider-electric.ca/fr/work/support/customer-care/contact-schneider-electric.jsp" title="support par email">Contactez le support</a><br />
                Website: <a href="https://www.schneider-electric.ca/fr/work/support/" title="détails sur le web">https://www.schneider-electric.ca/fr/work/support/</a>
                </p>
                <p>&nbsp;</p>
                <p><b>États Unis</b><br />
                Aux Etats-Unis, appelez: <a href="tel:1-877-342-5173" title="appuyez sur pour appeler">1-877-342-517</a> (<a href="https://www.schneider-electric.us/en/work/support/customer-care" title="détails sur le web">details</a>)<br />
                Le support technique est disponible du lundi au vendredi de 8h00 à 20h00 (EST).<br />
                <i>(Remarque: certains départements de support peuvent se terminer plus tôt)</i>
                </p>
                <p>Bavarder: <a href="https://www.schneider-electric.us/en/work/support/customer-care" title="contactez le support">Chattez avec support</a><i> (mêmes heures que le support technique)</i><br />
                Site Internet: <a href="https://www.schneider-electric.us/en/work/support" title="visitez le site web">https://www.schneider-electric.us/en/work/support</a>
                </p>
                </div>
                <div className={classes.TitleWrapper}>
                <h2>{translation[language].contactUs}</h2>
            </div>
        </Fragment>
        );

    default :
      return (
        <Fragment>
            <div className={classes.ContactInfoWrapper}>
                <p>The Schneider Electric Customer Care Center (CCC) is a single point of contact where qualified personnel answer your customer service and technical support questions. Two support centers are offered to support customers calling from both Canada and from the United States. Please select the call center for your country.</p>
                <p><b>Canada</b><br />
                In Canada call: <a href="tel:1-800-565-6699" title="tap to call">1-800-565-6699</a> (<a href="https://www.schneider-electric.ca/en/work/support/customer-care/contact-directory" title="details on the web">details</a>)<br />
                Press 1 for French<br />
                Press 2 for English</p>
                <p>Technical Support is available Monday - Friday, 8:00am - 7:00pm (English) and 8:00am - 5:00pm (French) (EST)<br />
                <i>(Note: Some support departments may end earlier)</i>
                </p>
                <p>Email: <a href="mailto:canadian-pss@schneider-electric.com" title="email support">Contact Support</a><br />
                Website: <a href="https://www.schneider-electric.ca/CIC" title="visit website">https://www.schneider-electric.ca/CIC</a>
                </p>
                <p>&nbsp;</p>
                <p><b>United States</b><br />
                In USA call: <a href="tel:1-877-342-5173" title="tap to call">1-877-342-5173</a> (<a href="https://www.schneider-electric.us/en/work/support/customer-care" title="details on the web">details</a>)<br />
                Technical Support is available Monday - Friday, 8:00am - 8:00pm (EST)<br />
                <i>(Note: Some support departments may end earlier)</i>
                </p>
                <p>Chat: <a href="
                https://www.schneider-electric.us/en/work/support/customer-care" title="contact support">Chat with support</a><i> (same hours as technical support)</i><br />
                Website: <a href="https://www.schneider-electric.us/en/work/support" title="visit website">https://www.schneider-electric.us/en/work/support</a>
                </p>
                </div>
                <div className={classes.TitleWrapper}>
                <h2>{translation[language].contactUs}</h2>
            </div>
        </Fragment>
        );
};
};

moreComponent.propTypes = {
  language: PropTypes.string.isRequired
};

export default moreComponent;
